export default "__VITE_ASSET__ChZxmnFV__"